import type { PaymentsTranslations } from "../interfaces/payments";

export const paymentsTranslations: PaymentsTranslations = {
  page_title: "Solicitudes de pagos",
  button_back_to_list: "Volver a la lista",
  button_new_payment: "Nuevo pago",
  section_new_payment_title: "Nuevo pago",
  button_create_payment: "Crear pago",
  button_clear_form: "Limpiar formulario",
  button_cancel: "Cancelar",
  toast_error_load: "Error al cargar pagos",
  toast_error_load_more: "Error al cargar más pagos",
  toast_success_create: "Pago creado correctamente",
  toast_error_create: "Error al crear el pago",
  toast_success_status: "Estado actualizado correctamente",
  toast_error_status: "Error al actualizar el estado",
  toast_success_cancel: "Pago cancelado correctamente",
  toast_error_cancel: "Error al cancelar el pago",
  toast_success_take: "Pago tomado correctamente",
  toast_error_take: "Error al tomar el pago",
  toast_success_release: "Pago liberado y devuelto a pendientes",
  toast_error_release: "Error al liberar el pago",
  toast_success_notify: "Cliente notificado correctamente",
  toast_error_notify: "Error al notificar al cliente",
  loading: "Cargando…",
  show_more: "Mostrar más",
  alt_comprobante_pago: "Comprobante de pago",

  card_status_pending: "Pendiente",
  card_status_in_progress: "En proceso",
  card_status_paid: "Pagado",
  card_beneficiary: "Beneficiario:",
  card_platform: "Plataforma:",
  card_date: "Fecha:",
  card_creation_date: "Fecha de creacion:",
  card_update_date: "Fecha de actualizacion:",
  card_note: "Nota:",
  card_created_by: "Creado por:",
  card_updated_by: "Actualizado por:",
  card_notify_client: "Cliente notificado",
  toast_success_taker_reminder: "Recordatorio enviado correctamente",
  toast_error_taker_reminder: "Error al enviar el recordatorio",
  card_url_has_label: "url_hash",
  card_network_label: "Red",
  card_copy: "Copiar",
  card_copied: "Copiado",
  card_copy_title: "Copiar",
  card_cancel: "Cancelar",
  card_take: "Tomar",
  card_take_continue: "Continuar",
  card_taken_by: "Tomado por {{name}}",
  card_taken_by_you: "Lo tienes tomado tú",
  card_release: "Liberar",
  card_release_admin: "Liberar (admin)",
  card_release_title: "Devolver el pago a pendientes para que otro usuario pueda tomarlo",
  card_view_history: "Ver historial",
  card_verified: "Verificado",
  card_payment_info: "Información de pago",
  card_receipts: "Comprobante",
  card_receipts_count: "Comprobantes",
  card_error_load: "Error al cargar",
  card_view: "Ver",
  card_alt_receipt_n: "Comprobante {{n}}",

  preview_payer: "Pagador:",
  preview_platform: "Plataforma:",
  preview_date: "Fecha:",
  preview_created_by: "Creado por:",

  column_pending: "Pendiente",
  column_in_progress: "En proceso",
  column_paid: "Pagado",
  column_empty_pending: "No hay pagos pendientes. Los nuevos pagos aparecerán aquí.",
  column_refresh: "Actualizar",
  column_refresh_aria: "Actualizar pagos",
  column_drag_in_progress: "Arrastra para En proceso",
  column_drag_paid: "Arrastra para Pagado",

  modal_cancel_title: "Cancelar pago",
  modal_cancel_description:
    "Por favor, indícanos el motivo por el cual deseas cancelar este pago. Esta acción no se puede deshacer una vez confirmada.",
  modal_cancel_label_reason: "Motivo de cancelación",
  modal_cancel_placeholder: "Escribe aquí el motivo de la cancelación...",
  modal_cancel_back: "Volver",
  modal_cancel_confirm: "Confirmar cancelación",
  modal_cancel_confirming: "Cancelando...",
  modal_cancel_required: "El motivo de cancelación es obligatorio.",
  modal_cancel_close_aria: "Cerrar",

  modal_take_title: "Tomar pago",
  modal_take_description:
    "¿Estás seguro que deseas tomar este pago? El pago pasará a estado «En proceso» y esta acción será registrada en el historial.",
  modal_take_back: "Volver",
  modal_take_confirm: "Tomar",
  modal_take_processing: "Procesando...",
  modal_take_close_aria: "Cerrar",

  modal_release_title: "Liberar pago",
  modal_release_description:
    "El pago volverá a «Pendiente» y quedará disponible para que cualquier operador lo tome. Esta acción será registrada en el historial.",
  modal_release_confirm: "Liberar",
  modal_release_admin_title: "Liberar pago de otro operador",
  modal_release_admin_description:
    "Este pago está tomado por otro operador. Al liberarlo perderá el bloqueo y el pago volverá a «Pendiente».",
  modal_release_admin_holder: "Tomado por {{name}}",
  modal_release_admin_warning:
    "Podría estar trabajando en él ahora mismo. Libéralo solo si el pago quedó bloqueado o si el operador no está disponible.",
  modal_release_admin_confirm: "Liberar de todas formas",
  modal_release_back: "Volver",
  modal_release_processing: "Liberando...",

  modal_paid_title: "Marcar como pagado",
  modal_paid_description:
    "¿Estás seguro que deseas marcar este pago como pagado? El pago pasará a estado «Pagado» y esta acción será registrada en el historial.",
  modal_paid_payment_source_label: "Salida de Banco",
  modal_paid_payment_source_placeholder: "Seleccione la salida de banco",
  modal_paid_payment_source_required: "Debe seleccionar la salida de banco.",
  modal_paid_comprobante_label: "Comprobante (imágenes)",
  modal_paid_comprobante_optional_label: "Comprobante (imágenes) (opcional)",
  modal_paid_comprobante_description: "PNG, JPG, WebP hasta 10 MB. Puedes elegir varios archivos.",
  modal_paid_comprobante_optional_description:
    "Opcional para USDT. PNG, JPG, WebP hasta 10 MB. Puedes elegir varios archivos.",
  modal_paid_url_has_label: "url_hash",
  modal_paid_url_has_placeholder: "Ingrese url_hash",
  modal_paid_comprobante_required: "Debe adjuntar al menos un comprobante.",
  modal_paid_url_has_required: "El campo url_hash es obligatorio para pagos en USDT.",
  modal_paid_back: "Volver",
  modal_paid_confirm: "Marcar como pagado",
  modal_paid_processing: "Procesando...",
  modal_paid_close_aria: "Cerrar",

  modal_history_title: "Historial del pago",
  modal_history_loading: "Cargando historial…",
  modal_history_error: "No se pudo cargar el historial.",
  modal_history_empty: "No hay registros en el historial.",
  modal_history_section_title: "Historial de cambios",
  modal_history_initial_status: "Estado inicial",
  modal_history_previous_status: "Estado anterior",
  modal_history_current_status: "Estado actual",
  modal_history_duration: "Duración",
  modal_history_close: "Cerrar",
  modal_history_close_aria: "Cerrar",
  status_pending: "Pendiente",
  status_in_progress: "En proceso",
  status_paid: "Pagado",
  status_cancelled: "Cancelado",
  status_archived: "Archivado",
  status_filed: "Archivado (filed)",
  change_type_created: "Creación",
  change_type_status: "Cambio de estado",
  change_type_data: "Actualización de datos",
  change_type_attachment: "Adjunto añadido",
  change_type_note: "Nota añadida",
  change_type_taken: "Tomado",

  modal_info_title: "Información de pago",
  modal_info_no_data: "No hay información de pago para este registro.",
  modal_info_amount_label: "Valor del pago",
  modal_info_close: "Cerrar",
  modal_info_confirm_payment: "Confirmar pago",
  modal_info_copy_title: "Copiar",
  modal_info_copy_amount_title: "Copiar valor del pago",
  modal_info_yes: "Sí",
  modal_info_no: "No",

  modal_info_field_llave_bre_b: "Llave Bre-B",
  modal_info_field_numero_celular_nequi: "Número celular asociado a Nequi",
  modal_info_field_banco_ach: "Banco",
  modal_info_field_tipo_cuenta: "Tipo de cuenta",
  modal_info_field_numero_cuenta: "Número de cuenta",
  modal_info_field_tipo_documento: "Tipo de documento",
  modal_info_field_numero_documento: "Número de documento",
  modal_info_field_tipo_llave_pix: "Tipo de llave Pix",
  modal_info_field_llave_pix: "Llave Pix",
  modal_info_field_clabe: "CLABE (18 dígitos)",
  modal_info_field_banco: "Banco",
  modal_info_field_rut: "RUT",
  modal_info_field_email: "Email",
  modal_info_field_numero_cci: "Número CCI",
  modal_info_field_documento_identidad: "Documento de identidad",
  modal_info_field_numero_celular_yape: "Número celular asociado a Yape",
  modal_info_field_numero_celular_plin: "Número celular asociado a Plin",
  modal_info_field_routing_number: "Routing number",
  modal_info_field_swift_bic: "SWIFT / BIC",
  modal_info_field_direccion_banco: "Dirección del banco",
  modal_info_field_email_telefono_zelle: "Email o número telefónico asociado",
  modal_info_field_iban: "IBAN",
  modal_info_field_tipo_identificador_fps: "Tipo de identificador",
  modal_info_field_identificador_fps: "Identificador FPS",
  modal_info_field_codigo_chats: "Código CHATS",
  modal_info_field_id_alipay: "ID Alipay",
  modal_info_field_id_wechat: "ID WeChat",
  modal_info_field_numero_cuenta_iban: "Número de cuenta IBAN",
  modal_info_field_numero_celular: "Número celular",
  modal_info_field_cbu_cvu: "CBU o CVU",
  modal_info_field_cbu: "CBU",
  modal_info_field_cvu: "CVU",
  modal_info_field_direccion_wallet: "Dirección de wallet",
  modal_info_field_binance_pay_uid: "UID",
  modal_info_field_binance_pay_email: "Email",

  validation_method_field_required: "Este campo es obligatorio.",

  form_payer_subclient_placeholder: "Selecciona el pagador (subcliente)",

  form_client_search_empty_message:
    "No se encontraron registros de clientes con esa búsqueda. Por favor ingresa al módulo de clientes y regístralo.",
  form_client_search_go_to_clients: "Ir a clientes",
  form_client_search_dropdown_empty: "Sin resultados para esta búsqueda.",

  form_payer_accounts_loading: "Cargando cuentas del beneficiario…",
  form_payer_accounts_missing:
    "El beneficiario debe de tener al menos una cuenta registrada, por favor ingrese al modulo de clientes y registrela.",
  form_payer_account_label: "Cuenta del beneficiario",
  form_payer_account_placeholder: "Seleccione una cuenta",
  validation_payer_account_required: "Seleccione la cuenta del beneficiario.",

  form_method_section_title: "Datos del método de pago",
  form_method_select_placeholder: "Seleccionar {{label}}...",
  form_method_pix_select_type_first: "Selecciona primero el tipo de llave",
  form_method_option_ahorros: "Ahorros",
  form_method_option_corriente: "Corriente",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Pasaporte",
  form_method_option_ppt: "Ppt",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Teléfono",
  form_method_option_llave_aleatoria: "Llave aleatoria",
  form_method_option_id_fps: "ID FPS",

  pending_totals_title: "Totales pendientes por moneda",
  pending_totals_subtitle: "Visualiza de un vistazo el monto total que queda por procesar en cada moneda.",
  pending_totals_card_label: "Total pendiente",
  pending_totals_loading: "Cargando totales…",
  pending_totals_empty: "No hay pagos pendientes en este momento.",
  pending_totals_error: "Error al cargar los totales pendientes",
  pending_totals_refresh: "Actualizar",
  pending_totals_refresh_aria: "Actualizar totales pendientes",
};
